<template>
  <div>
    <h3 class="font-medium text-m1 mb-16">Ratings & reviews</h3>
    <ratings-overview :count="totalReviewCount" :average="starAggregate" :distributionData="ratingsDistribution" />
    <reviews-list :reviews="reviews" :total-review-count="totalReviewCount" class="mt-16" @view-more-reviews="viewMoreHandler" />
  </div>
</template>

<script lang="ts">
import RatingsOverview from '@/components/ratings_overview/RatingsOverview.vue';
import ReviewsList from '@/components/reviews_list/ReviewsList.vue';

interface DistributionData {
  count: number;
  percent: number;
  stars: number;
}

export default {
  name: 'RatingsAndReviews',
  components: {
    RatingsOverview,
    ReviewsList,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reviewsFetchCount: 3,
    };
  },
  computed: {
    reviews(): any {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.edges || [];
    },
    starAggregate(): number {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.starAggregate || 0;
    },
    totalReviewCount(): number {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.totalReviewCount || 0;
    },
    ratingsDistribution(): Array<DistributionData> {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.ratingsDistribution || [];
    },
  },
  methods: {
    viewMoreHandler(): void {
      // Increase the number of displayed reviews by 3
      this.reviewsFetchCount += 3;
      this.$emit('input', this.reviewsFetchCount);
    },
  },
};
</script>
